import fool from "./RWS_Tarot_00_Fool.jpg";
import magician from "./RWS_Tarot_01_Magician.jpg";
import highPriestess from "./RWS_Tarot_02_High_Priestess.jpg";
import empress from "./RWS_Tarot_03_Empress.jpg";
import emperer from "./RWS_Tarot_04_Emperor.jpg";
import hierophant from "./RWS_Tarot_05_Hierophant.jpg";
import lovers from "./RWS_Tarot_06_Lovers.jpg";
import chariot from "./RWS_Tarot_07_Chariot.jpg";
import strength from "./RWS_Tarot_08_Strength.jpg";
import hermit from "./RWS_Tarot_09_Hermit.jpg";
import wheelOfFortune from "./RWS_Tarot_10_Wheel_of_Fortune.jpg";
import justice from "./RWS_Tarot_11_Justice.jpg";
import hangedMan from "./RWS_Tarot_12_Hanged_Man.jpg";
import death from "./RWS_Tarot_13_Death.jpg";
import temperance from "./RWS_Tarot_14_Temperance.jpg";
import devil from "./RWS_Tarot_15_Devil.jpg";
import tower from "./RWS_Tarot_16_Tower.jpg";
import star from "./RWS_Tarot_17_Star.jpg";
import moon from "./RWS_Tarot_18_Moon.jpg";
import sun from "./RWS_Tarot_19_Sun.jpg";
import judgement from "./RWS_Tarot_20_Judgement.jpg";
import world from "./RWS_Tarot_21_World.jpg";

const majorArcana = [
  fool,
  magician,
  highPriestess,
  emperer,
  empress,
  hierophant,
  lovers,
  chariot,
  strength,
  hermit,
  wheelOfFortune,
  justice,
  hangedMan,
  death,
  temperance,
  devil,
  tower,
  star,
  moon,
  sun,
  judgement,
  world,
];

export default majorArcana;
